import React, { useState } from 'react';
import { AddUserToInstanceButton } from './AddUserToInstanceButton';
import { AddUserToInstanceModal } from './AddUserToInstanceModal';

interface AddUserToInstanceProps {
  readonly schedulingInstanceId: number;
  readonly showFullButton?: boolean;
  readonly disabled?: boolean;
}

export const AddUserToInstance = ({
  schedulingInstanceId,
  showFullButton = false,
  disabled = false,
}: AddUserToInstanceProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <AddUserToInstanceButton
        showFullButton={showFullButton}
        onClick={() => setIsModalOpen(true)}
        disabled={disabled}
      />
      <AddUserToInstanceModal
        schedulingInstanceId={schedulingInstanceId}
        isOpen={isModalOpen}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};
